import { classNames } from 'libs/react';
import { React } from 'libs/react';
import { Icon } from 'components/Icon';
import './AvailabilityDealList.scss';
/**
 * @component AvailabilityDealList
 * @since 1.0.0
 * One group of overlapping quotes (confirmed or pending), each row opening
 * the quote in a new tab. The quote being configured is tagged, not linked.
 */
export function AvailabilityDealList(props) {
    const { status, title, deals, currentDealId } = props;
    if (deals.length === 0) {
        return null;
    }
    const className = classNames('availability-deal-list', 'availability-deal-list--' + status, props.className);
    return (React.createElement("div", { className: className },
        React.createElement("div", { className: "availability-deal-list-header" },
            React.createElement("span", { className: "availability-deal-list-dot" }),
            React.createElement("span", { className: "availability-deal-list-title" }, title),
            React.createElement("span", { className: "availability-deal-list-count" }, deals.length)),
        React.createElement("div", { className: "availability-deal-list-rows" }, deals.map((d) => {
            var _a;
            const isCurrent = Boolean(currentDealId) && d.id === currentDealId;
            const number = d.number ? `#${d.number}` : null;
            // Default titles already end with the number: don't repeat it
            const showNumber = number !== null && Boolean(d.title) && !((_a = d.title) === null || _a === void 0 ? void 0 : _a.includes(number));
            const content = (React.createElement(React.Fragment, null,
                React.createElement("span", { className: "availability-deal-list-name" }, d.title || number || '—'),
                showNumber && (React.createElement("span", { className: "availability-deal-list-number" }, number)),
                isCurrent ? (React.createElement("span", { className: "availability-deal-list-tag" }, t('This quote'))) : (React.createElement(Icon, { className: "availability-deal-list-open", value: "far external-link" }))));
            if (isCurrent) {
                return (React.createElement("div", { key: d.id, className: "availability-deal-list-row is-current" }, content));
            }
            return (React.createElement("a", { key: d.id, className: "availability-deal-list-row", href: `/quotes/details/${d.id}`, target: "_blank", rel: "noopener noreferrer", title: t('Open quote') }, content));
        }))));
}
